"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildGrantTypesFields = void 0;
exports.buildStateFromFormChange = buildStateFromFormChange;
exports.buildStateFromGrantTypeChange = buildStateFromGrantTypeChange;
exports.initializeForm = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("../components/GrantTypes/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var includesAnypointRedirectURIs = function includesAnypointRedirectURIs(anypointRedirectURIs, redirectURIs) {
  return redirectURIs.some(function (redirectURI) {
    return anypointRedirectURIs.includes(redirectURI);
  });
};
var removeAnypointRedirectURIs = function removeAnypointRedirectURIs(anypointRedirectURIs, redirectURIs) {
  return redirectURIs.filter(function (redirectURI) {
    return !anypointRedirectURIs.includes(redirectURI);
  });
};
var initializeForm = exports.initializeForm = function initializeForm(anypointRedirectURIs, application) {
  if (!application) {
    return {};
  }

  // Mark existing grant types as selected
  var grantTypesFields = application.grantTypes.reduce(function (acc, grantType) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, (0, _utils.getGrantTypeValueKey)(grantType), true));
  }, {});
  var redirectURI = removeAnypointRedirectURIs(anypointRedirectURIs, application.redirectUri || []).join(',');
  return _objectSpread(_objectSpread(_objectSpread({}, application), grantTypesFields), {}, {
    redirectURI: redirectURI,
    applicationURL: application.url,
    apiEndpoints: includesAnypointRedirectURIs(anypointRedirectURIs, application.redirectUri)
  });
};
function buildStateFromGrantTypeChange(_ref) {
  var grantType = _ref.grantType,
    value = _ref.value,
    grantTypes = _ref.grantTypes,
    initialForm = _ref.initialForm;
  var form = _objectSpread({}, initialForm);
  form[(0, _utils.getGrantTypeValueKey)(grantType.name)] = value;
  return {
    grantTypes: {
      isGrantTypesDirty: true,
      errors: []
    },
    form: _objectSpread({}, (0, _utils.mergeGrantTypes)(form, grantTypes))
  };
}
function buildStateFromFormChange(_ref2) {
  var value = _ref2.value,
    target = _ref2.target,
    grantTypes = _ref2.grantTypes,
    initialForm = _ref2.initialForm;
  var grantType = grantTypes.find(function ($grantType) {
    return (0, _utils.getGrantTypeValueKey)($grantType.name) === target;
  });
  var form = (0, _utils.mergeGrantTypes)(initialForm, grantTypes);
  if (grantType) {
    return buildStateFromGrantTypeChange({
      grantType: grantType,
      value: value[target],
      grantTypes: grantTypes,
      initialForm: initialForm
    });
  }
  return {
    form: _objectSpread(_objectSpread({}, form), {}, (0, _defineProperty2.default)({}, target, value[target])),
    grantTypes: {}
  };
}
var buildGrantTypesFields = exports.buildGrantTypesFields = function buildGrantTypesFields(grantTypes) {
  return grantTypes.reduce(function (accum, grantType) {
    return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _utils.getGrantTypeValueKey)(grantType.name), grantType.required), (0, _utils.getGrantTypeDisabledKey)(grantType.name), grantType.required));
  }, {});
};
//# sourceMappingURL=state.js.map